<template>
  <div class="report-page" v-loading="loading">
    <template v-if="report">
      <!-- 汇总指标卡片 -->
      <el-row :gutter="16" class="summary-row">
        <el-col :xs="12" :sm="12" :md="6" v-for="item in report.summary" :key="item.label" class="summary-col">
          <el-card shadow="hover" class="summary-card">
            <div class="summary-value">{{ formatSummary(item.value) }}</div>
            <div class="summary-label">{{ item.label }}</div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 报表明细表格 -->
      <el-card shadow="never" class="table-card">
        <template #header>
          <span class="table-title">{{ report.title }}</span>
          <span class="table-tip">数据来源：接口 /api/report/{{ reportKey }}</span>
          <el-button class="refresh-btn" link type="primary" :icon="Refresh" @click="fetchData">刷新</el-button>
        </template>
        <el-table :data="report.rows" border stripe>
          <el-table-column type="index" label="#" width="50" align="center" />
          <el-table-column
            v-for="col in report.columns"
            :key="col.prop"
            :prop="col.prop"
            :label="col.label"
            :align="col.type === 'amount' || col.type === 'number' ? 'right' : 'left'"
            min-width="120"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <span v-if="col.type === 'amount'" class="amount">{{ formatAmount(row[col.prop]) }}</span>
              <span v-else>{{ displayValue(row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <template #empty>
            <el-empty description="暂无报表数据" :image-size="80" />
          </template>
        </el-table>
      </el-card>
    </template>

    <el-empty v-else-if="!loading" description="暂无报表数据" />
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { Refresh } from '@element-plus/icons-vue'
import { getReport } from '@/api'

const route = useRoute()
const report = ref(null)
const loading = ref(false)

// 报表标识取自路由末段(/report/sales -> sales),与后端 ReportController 路径一致
const reportKey = computed(() => route.meta.reportKey)

async function fetchData() {
  if (!reportKey.value) return
  loading.value = true
  try {
    report.value = await getReport(reportKey.value)
  } finally {
    loading.value = false
  }
}

function displayValue(val) {
  return val === '' || val == null ? '-' : val
}

function formatAmount(val) {
  const n = Number(val)
  return Number.isNaN(n) ? displayValue(val) : n.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

// 汇总卡片:百分比等已带单位的字符串原样展示,纯数字做千分位
function formatSummary(val) {
  if (val == null || val === '') return '-'
  if (typeof val === 'string') return val
  const n = Number(val)
  if (Number.isNaN(n)) return val
  return Number.isInteger(n) ? n.toLocaleString('zh-CN') : n.toLocaleString('zh-CN', { maximumFractionDigits: 2 })
}

// 切换报表路由时重新加载
watch(() => route.meta.reportKey, fetchData)

onMounted(fetchData)
</script>

<style scoped>
.summary-row {
  margin-bottom: 16px;
}
.summary-col {
  margin-bottom: 12px;
}
.summary-card {
  text-align: center;
}
.summary-value {
  font-size: 24px;
  font-weight: 700;
  color: #409eff;
}
.summary-label {
  margin-top: 6px;
  font-size: 13px;
  color: #909399;
}
.table-title {
  font-weight: 600;
}
.table-tip {
  margin-left: 12px;
  font-size: 12px;
  color: #909399;
}
.refresh-btn {
  margin-left: 12px;
}
.amount {
  color: #e6a23c;
  font-weight: 500;
}
</style>
